
































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";

@Component({
  components: {
    "program-level": ProgramLevel,
  },
})
export default class SubjectSelect extends Vue {
  private service = new GeneralService();
  public entities = [
    { fullName: "Academic Calendar" },
    { fullName: "Attendance" },
    { fullName: "Timetable" },
    { fullName: "Exam Results" },
    { fullName: "Fees" },
  ];
  private boards: any = [];
  private activated: boolean = false;
  private boardSelected = false;
  private level_id = JSON.parse(localStorage[config.programSelect] || null);
  private auth = new AuthService();
  private studentInfo: any = [];
  private selectedPart = 0;
  private showDropdown = false;
  private isDitProgram = false;
  private hasMultiple = false;

  private selectModule(name) {
    if (name == "Timetable") {
      this.$router.push("/timetable");
    } else if (name == "Attendance") {
      this.$router.push("/attend");
    } else if (name == "Exam Results") {
      this.$router.push("/examresult");
    } else if (name == "Fees") {
      this.$router.push("/fees");
    } else if (name == "Academic Calendar") {
      window.location.href = "/academic-calendar";
    }
  }

  private switchPart() {
    if (this.level_id.part.indexOf("II") > -1) {
      this.navigateTo(JSON.parse(localStorage[config.studentPartInfo])[0]);
    } else {
      this.navigateTo(JSON.parse(localStorage[config.studentPartInfo])[1]);
    }
    if (this.selectedPart == 0) this.selectedPart = 1;
    else this.selectedPart = 0;

    localStorage[config.userInfoEMS] =
      this.studentInfo[this.selectedPart].Class_Level_ID;
  }

  private handlePartSwitchCMS() {
    if (this.isDitProgram) {
      // DIT: show dropdown for semester selection
      this.showDropdown = !this.showDropdown;
    } else {
      // Non-DIT: direct toggle between Part-I and Part-II
      this.switchPart();
    }
  }

  private selectPartCMS(index) {
    this.showDropdown = false;
    this.selectedPart = index;
    localStorage[config.userInfoEMS] =
      this.studentInfo[this.selectedPart].Class_Level_ID;

    const storedArr = JSON.parse(localStorage[config.studentPartInfo] || '[]');
    const selectedClass = this.studentInfo[index];
    if (!selectedClass) return;

    const target = storedArr.find(p =>
      p.fullName && selectedClass.Class &&
      p.fullName.replace(/\s+/g, '').toLowerCase() === selectedClass.Class.replace(/\s+/g, '').toLowerCase()
    );

    if (target) {
      this.navigateTo(target);
    }
    window.location.reload();
  }

  private navigateTo(entity) {
    localStorage[config.classLevl] = entity.clId;
    localStorage[config.programSelect] = JSON.stringify({
      val: entity.clId,
      user: this.auth.session.userId,
      part: entity.fullName,
      name: this.auth.session.varification,
      board: this.level_id.board,
    });
    window.location.reload();
  }

  mounted() {
    // Check if DIT program
    if (this.auth.session && this.auth.session.varification &&
        this.auth.session.varification.indexOf('DIT-') !== -1) {
      this.isDitProgram = true;
    }

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null" ||
      this.level_id.user !== this.auth.session.userId
    ) {
      router.push("select?type=cms");
    }

    let username = this.auth.session.userName.split("@")[0];
    if (this.level_id.part.indexOf("II") > -1) {
      this.selectedPart = 1;
    }
    this.service.getInfoEMS(username).then((result) => {
      this.studentInfo = result.data;
      this.studentInfo.sort((a, b) => {
        return a.Class > b.Class ? 1 : -1;
      });
      this.hasMultiple = result.data.length > 1 ? true : false;
      localStorage[config.userInfoEMS] =
        this.studentInfo[this.selectedPart].Class_Level_ID;
    });
  }
}
